export const byAscendingIndex = (a, b) => a.index < b.index ? -1 : 1
export const byDescendingIndex = (a, b) => a.index < b.index ? 1 : -1
export const byAscendingVersion = (a, b) => a.version < b.version ? -1 : 1
export const byDescendingVersion = (a, b) => a.version < b.version ? 1 : -1
